/**
 * Display name for user ids stored as email (or plain username).
 * Returns the local part before @; non-email values are shown as-is.
 */
export function displayUsername(emailOrId) {
  if (emailOrId == null || emailOrId === '') return '';
  const s = String(emailOrId).trim();
  const at = s.indexOf('@');
  return at >= 0 ? s.slice(0, at) : s;
}

/** @deprecated Prefer {@link displayUsername}; kept for existing imports. */
export function stripSportradarDomain(emailOrId) {
  return displayUsername(emailOrId);
}
